import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

/**
 * Lu Chip for formly... In charge for having values which are not predefined where we offer user to add multiple string or number values
 */
@Component({
	templateUrl: './lu-chip-formly.component.html',
	styleUrls: ['./lu-chip-formly.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LuChipFormlyComponent extends FieldType implements OnInit {
	/**
	 * Added values inside chip component
	 */
	addedValues: (string | number)[] = [];

	/**
	 * Constructor
	 */
	constructor() {
		super();
	}

	/**
	 * On Component Init, write inital values and check if observing onInit action from outside of this component
	 */
	ngOnInit(): void {
		this.writeValue(this.formControl.value || []);
		this.formControl.updateValueAndValidity();
		this.onChipComponentReady(this);
	}

	/**
	 * Once chip has been deleted - we emit to outer scope
	 */
	onChipDelete($event: this): void {
		if (!!this.to.onChipDelete) {
			this.to.onChipDelete($event);
		}
	}

	/**
	 * Once chip component is ready - we emit to outer scope
	 */
	onChipComponentReady($event: this): void {
		if (!!this.to.onChipComponentReady) {
			this.to.onChipComponentReady($event);
		}
	}

	/**
	 * Once chip has been added - we emit to outer scope
	 */
	onChipAdded($event): void {
		if (!!this.to.onChipAdded) {
			this.to.onChipAdded($event);
		}
	}

	/**
	 * On blur - mark as touched and - if field is empty and doesn't have required error we reset errors since there are some values
	 */
	onBlur(value: string): void {
		this.formControl.markAsTouched();
		if (!value.trim() && !this.formControl?.errors?.required) {
			this.formControl.setErrors(null);
		}
	}

	/**
	 * Write values to addedValues and also attach to template options
	 */
	writeValue(values: any): void {
		this.addedValues = values;
		this.to.addedValues = this.addedValues || [];
	}

	/**
	 * Add value on ENTER to chip array
	 */
	addValue(element: HTMLInputElement, event?: Event): void {
		if (!!event) {
			event.stopPropagation();
			event.preventDefault();
		}
		let value: string | number = element.value.trim();
		this.formControl.setValue(value);
		if (this.formControl.invalid) {
			if (this.addedValues.length) {
				this.formControl.setValue(this.addedValues);
			} else {
				this.formControl.setValue(this.addedValues, { emitEvent: false });
			}

			this.onBlur(value);
			return;
		}
		const { type } = this.to;
		value = type === 'number' ? +value : value;
		this.formControl.setValue([...this.addedValues, value]);
		this.writeValue(this.formControl.value);
		element.value = '';
		this.onChipAdded(this);
	}

	/**
	 * On item remove chip method
	 */
	removeItem(index: number): void {
		this.addedValues.splice(index, 1);
		this.formControl.setValue([...this.addedValues]);
		this.onChipDelete(this);
	}
}
